import { FC } from 'react';
import { lozingsvormenV3 } from '@/lib/types/relatie';
import { LozingsvormBase } from '../lozingsvorm-base';

interface Properties {
  teeltwijze: number;
}

export const LozingsvormV3: FC<Properties> = ({ teeltwijze }) => <LozingsvormBase teeltwijze={teeltwijze} values={lozingsvormenV3} />;
